{
  "digital_twin_network": {
    "title": "Es konnte keine Verbindung zum Digital Twin hergestellt werden",
    "subtitle": "Lassen Sie uns einige Überprüfungen durchführen, um zu sehen, was schief gelaufen ist...",
    "title_success": "Der Verbindungstest war erfolgreich",
    "subtitle_success": "Um eine Verbindung zum digitalen Zwilling herzustellen, kehren Sie zur Karte zurück und klicken Sie auf die Schaltfläche Digitaler Zwilling",
    "support_1": " Bitte überprüfen Sie die ",
    "documentation": "Dokumentation",
    "support_2": " für Firewall- und Verbindungseinstellungen. Wenn dieses Problem weiterhin besteht, wenden Sie sich bitte an den Support unter",
    "iventis_card": {
      "title": "Iventis",
      "subtitle": "Wichtigste Anwendungsdienste"
    },
    "websocket_card": {
      "title": "Websocket",
      "subtitle": "Stellen Sie die Digital Twin-Verbindung her"
    },
    "webRTC_card": {
      "title": "WebRTC",
      "subtitle": "Video- und Echtzeitkommunikation zum digitalen Zwilling"
    },
    "return_to_map": "Zurück zur Karte",
    "recommended_actions": {
      "title": "Vorgeschlagene Aktion",
      "iventis": "Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Support unter",
      "websocket": "Bitte überprüfen Sie Ihre Netzwerk- und Firewalleinstellungen, um sicherzustellen, dass Websocket-Verbindungen zulässig sind und dass keine Firewallregeln die Verbindung zu iventis.com blockieren. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Support unter",
      "webRTC": "Bitte überprüfen Sie Ihre Netzwerk- und Firewalleinstellungen, um sicherzustellen, dass WebRTC-Verbindungen zulässig sind und dass die Ports 19302, 19303 und 10000-65535 geöffnet sind und STUN- und TURN-Anfragen an iventis.com zulassen. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Support unter"
    },
    "testing": "Wir testen Ihre Verbindung, bitte warten Sie..."
  },
  "model_preview": {
    "toggle_bounding_box": "Umschalten des Bounding-Feldes",
    "bounding_box_check": "Prüfen Sie, ob das Modell in den Begrenzungsrahmen passt",
    "bounding_box_check_dimensions": "Vergewissern Sie sich, dass das Modell in den Begrenzungsrahmen passt und die Abmessungen korrekt sind",
    "dimensions_warning": "Durch das Bearbeiten der Abmessungen wird die Modellgröße nicht geändert. Diese Werte werden als Referenzmaße verwendet, wenn benutzerdefinierte Größen in Ebenenstilen angewendet werden",
    "length_axis_colour": "Rote Achse",
    "width_axis_colour": "Grüne Achse",
    "height_axis_colour": "Blaue Achse",
    "advanced_options": "Fortgeschritten"
  },
  "data_table_filter": {
    "operator": "Betreiber"
  },
  "map_settings": {
    "interface_style": "Stil der Kartenoberfläche",
    "compressed": "Komprimiert",
    "spacious": "Geräumig"
  }
}